import _get from 'lodash/get';
import { isVideoPlaybackActive } from '../player/player.selectors';

export const getScreenSaverData = state => _get(state, 'screenSaver.screenSaverData');

export const getScreenSaverIsLocked = state =>
  Boolean(_get(state, 'screenSaver.isLocked')) || isVideoPlaybackActive(state);
